export default [
  {
    path: '/operate/board',
    name: 'OperateBoardList',
    component: () => import('@/views/operate/BoardList.vue')
  },
  {
    path: '/operate/board/:boardNo',
    name: 'OperateBoardView',
    component: () => import('@/views/operate/Board.vue')
  },
  {
    path: '/operate/inquiry/user',
    name: 'OperateInquiryList',
    component: () => import('@/views/operate/InquiryList.vue')
  },
  {
    path: '/operate/inquiry/non-user',
    name: 'OperateNonUserInquiryList',
    component: () => import('@/views/operate/InquiryList.vue')
  },
  {
    path: '/operate/inquiry/user/:inquiryNo',
    name: 'OperateInquiryView',
    component: () => import('@/views/operate/Inquiry.vue')
  },
  {
    path: '/operate/inquiry/non-user/:inquiryNo',
    name: 'OperateNonUserInquiryView',
    component: () => import('@/views/operate/NonInquiry.vue')
  },

  {
    path: '/operate/banner',
    name: 'OperateBannerList',
    component: () => import('@/views/operate/BannerList.vue')
  },
  {
    path: '/operate/banner/:bannerNo',
    name: 'OperateBannerView',
    component: () => import('@/views/operate/Banner.vue')
  },
  {
    path: '/operate/menu',
    name: 'OperateMenuList',
    component: () => import('@/views/operate/Menu.vue')
  },
  {
    path: '/operate/push',
    name: 'OperatePushList',
    component: () => import('@/views/operate/PushList.vue')
  },
  {
    path: '/operate/push/:pushNo',
    name: 'OperatePushView',
    component: () => import('@/views/operate/Push.vue')
  }
];
